'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import Button from './Button';

export default function SuccessToast({ message, action, onDismiss, announce = true }: {
  message: string;
  action?: { href: string; label: string };
  onDismiss: () => void;
  announce?: boolean;
}) {
  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);
  useEffect(() => {
    if (hovered || focused) return;
    const timer = window.setTimeout(onDismiss, 7000);
    return () => window.clearTimeout(timer);
  }, [message, onDismiss, hovered, focused]);

  return <div onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} onFocusCapture={() => setFocused(true)} onBlurCapture={event => { if (!event.currentTarget.contains(event.relatedTarget)) setFocused(false); }} className="fixed bottom-5 right-5 z-[60] flex max-w-[calc(100vw-2.5rem)] items-center gap-3 rounded-xl border border-border bg-card py-3 pl-4 pr-2 text-sm text-foreground shadow-lg sm:max-w-sm">
    <span aria-hidden="true" className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/15 text-primary"><svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12 4 4L19 6" /></svg></span>
    <div className="min-w-0">
      <p role={announce ? 'status' : undefined} aria-live={announce ? 'polite' : undefined} aria-atomic={announce ? 'true' : undefined} className="break-words leading-5">{message}</p>
      {action && <Link href={action.href} onClick={onDismiss} className="mt-1 inline-flex min-h-6 items-center gap-1.5 rounded-sm text-sm font-medium text-primary underline-offset-4 hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">{action.label}<span aria-hidden="true">→</span></Link>}
    </div>
    <Button variant="ghost" icon aria-label="Dismiss save notification" onClick={onDismiss}><svg aria-hidden="true" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="m6 6 12 12M18 6 6 18" /></svg></Button>
  </div>;
}
